import { Button, Checkbox, Divider, Empty, Form, Radio, Select, Spin, Tooltip } from 'antd'
import { useEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import { DownOutlined, UpOutlined } from '@ant-design/icons'

export default function SkuDynamic(props) {
  const { formList, onSubmit, loading, currentItem, setMaterialDynaOptions } = props
  const [list, setList] = useState<any>([])
  const [form] = Form.useForm()
  const [btnLoading, setBtnLoading] = useState(false)
  const elementRefs = useRef<Record<string, HTMLDivElement | null>>({})
  const [showButtons, setShowButtons] = useState({})

  // 初始化
  useEffect(() => {
    setList(formList)
  }, [formList])
  const onChange = (item, value, index) => {
    let newList: any = [...list]
    if (value) {
      item.skuDynamicOptionVos = item.skuDynamicOptionVos.map(option => {
        if (option.id === value) {
          item.optionId = option.id
          item.optionName = option.name
        }
        return {
          ...option,
          isActive: option.id === value,
        }
      })
    } else {
      newList[index].optionId = undefined
      newList[index].optionName = ''
    }
    newList[index] = item
    console.log(newList)
    setList(newList)
    setMaterialDynaOptions?.(newList)
    // onSubmit(list, currentItem)
  }
  const expandDetail = (id: string) => {
    let newList: any = [...list]

    newList = newList?.map((kit: any) => {
      if (kit.id === id) {
        return {
          ...kit,
          isExpand: true,
        }
      }
      return {
        ...kit,
      }
    })
    setList([...newList])
  }

  const closeDetail = (id: string, type = 'edit') => {
    let newList: any = [...list]
    newList = newList?.map((kit: any) => {
      if (kit.id === id) {
        return {
          ...kit,
          isExpand: false,
        }
      }
      return {
        ...kit,
      }
    })
    setList([...newList])
  }
  return (
    <div className={styles.KitDetailDialogBox}>
      <div className={styles.orderDetail} style={{ paddingBottom: '0px' }}>
        {list?.map((item: any, itemIndex: number) => {
          return (
            <div key={'kitItem' + itemIndex} className={styles.chooseBox}>
              <div className={styles.chooseTitle}>
                <p className={styles.titleFont}>{item?.name}</p>
              </div>
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div
                  key={'kitItemList' + itemIndex}
                  className={styles.chooseList}
                  ref={el => (elementRefs.current[item.id] = el)}
                  style={{ maxHeight: item.isExpand ? 'fit-content' : '420px' }}
                >
                  {item?.skuDynamicOptionVos &&
                    item?.skuDynamicOptionVos?.length !== 0 &&
                    item?.skuDynamicOptionVos?.map((attr: any, attrIndex: number) => (
                      <div
                        key={'kitItemAttr' + attrIndex}
                        className={`${styles.item} ${attr.disabled ? styles.disabled : ''} ${attr.isActive ? styles.itemActive : ''}`}
                        onClick={() => {
                          if (attr.disabled) {
                            return
                          }
                          onChange(item, attr.id, itemIndex)
                        }}
                      >
                        <div className={styles.valueNameBox}>
                          <Tooltip title={attr?.name} placement="topLeft">
                            <div className={styles.overflowText}> {attr?.name}</div>
                          </Tooltip>
                        </div>
                      </div>
                    ))}
                </div>
                {!item.isExpand && showButtons[item.id] ? (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#2D2D2E',
                    }}
                    onClick={() => {
                      expandDetail(item?.id)
                    }}
                  >
                    展开全部
                    <DownOutlined style={{ marginLeft: 4 }} />
                  </div>
                ) : null}
                {item.isExpand && showButtons[item.id] ? (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#2D2D2E',
                      marginTop: '8px',
                    }}
                    onClick={() => {
                      closeDetail(item?.id)
                    }}
                  >
                    收起全部
                    <UpOutlined style={{ marginLeft: 4 }} />
                  </div>
                ) : null}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
